export default __webpack_public_path__ + "static/ibmax2-36aab7837be9297a3635ae6dc8914d2d.jpg";